import { render, staticRenderFns } from "./UserServiceAgreement.vue?vue&type=template&id=3218b014&scoped=true&"
import script from "./UserServiceAgreement.vue?vue&type=script&lang=js&"
export * from "./UserServiceAgreement.vue?vue&type=script&lang=js&"
import style0 from "./UserServiceAgreement.vue?vue&type=style&index=0&id=3218b014&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3218b014",
  null
  
)

export default component.exports